import { Link } from "react-router-dom";
import LoadJscript from "../components/LoadJscript";
import Newsletter from "../components/Newsletter";
const About = () => {
    return (
      <main>
         <div className="inner-banner inner-banner-bg">
            <div className="container">
                <div className="inner-title text-center">
                    <h3>About us</h3>
                    <ul>
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>About Us</li>
                    </ul>
                </div>
            </div>
        </div>
       
        <div className="enrolled-area-two pt-100 pb-70">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="enrolled-img-three mb-30 pr-20">
                            <img src="assets/images/enrolled/enrolled-img3.jpg" alt="Enrolled"/>
                            <div className="enrolled-img-content">
                                <i className="flaticon-discount"></i>
                                <div className="content">
                                    <h3>Get 40% off</h3>
                                    <p>Every course</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="enrolled-content mb-30">
                            <div className="section-title">
                                <span>WHO WE ARE</span>
                                <h2>We have the most qualified instructors in your hometown.</h2>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.
                                </p>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-6">
                                    <ul className="enrolled-list">
                                        <li><i className="flaticon-check"></i> Full lifetime access</li>
                                        <li><i className="flaticon-check"></i> Certificate of completion</li>
                                    </ul>
                                </div>

                                <div className="col-lg-6 col-6">
                                    <ul className="enrolled-list">
                                        <li><i className="flaticon-check"></i> 20+ downloadable resources</li>
                                        <li><i className="flaticon-check"></i> Free trial 7 days</li>
                                    </ul>
                                </div>
                            </div>
                            <a href="courses.html" className="default-btn border-radius-50">Enrolled today</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <div className="counter-area-three pb-70">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-6">
                        <div className="counter-card box-shadow">
                            <i className="flaticon-online-course"></i>
                            <h3><span className="odometer" data-count="15000">00000</span>+</h3>
                            <p>Courses & videos</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-6">
                        <div className="counter-card box-shadow">
                            <i className="flaticon-student"></i>
                            <h3><span className="odometer" data-count="145000">000000</span>+</h3>
                            <p>Students enrolled</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-6">
                        <div className="counter-card box-shadow">
                            <i className="flaticon-online-course-1"></i>
                            <h3><span className="odometer" data-count="10000">00000</span>+</h3>
                            <p>Courses instructors</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-6">
                        <div className="counter-card box-shadow">
                            <i className="flaticon-customer-satisfaction"></i>
                            <h3><span className="odometer" data-count="100">000</span>%</h3>
                            <p>Satisfaction rate</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <div className="testimonials-area section-bg pt-100 pb-100">
            <div className="container">
                <div className="section-title text-center">
                    <span>TESTIMONIAL</span>
                    <h2>What people say about us</h2>
                </div>
                <div className="testimonials-slider-two owl-carousel owl-theme">
                    <div className="testimonials-card-two">
                        <div className="rating">
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                        </div>
                        <p>“Morbi porttitor ligula id varius consectetur. Integer ipsum justo, congue sit amet massa vel, porttitor semper magna. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus.”</p>
                        <div className="content">
                            <img src="assets/images/testimonials/testimonials-img1.jpg" alt="testimonials" />
                            <h3>Nikolas brooten</h3>
                            <span>Student</span>
                        </div>
                        <div className="quote"> <i className="flaticon-quote"></i></div>
                    </div>
                    <div className="testimonials-card-two">
                        <div className="rating">
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                        </div>
                        <p>“Morbi porttitor ligula id varius consectetur. Integer ipsum justo, congue sit amet massa vel, porttitor semper magna. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus.”</p>
                        <div className="content">
                            <img src="assets/images/testimonials/testimonials-img2.jpg" alt="testimonials" />
                            <h3>Terry ambady</h3>
                            <span>Content strategist</span>
                        </div>
                        <div className="quote"> <i className="flaticon-quote"></i></div>
                    </div>
                    <div className="testimonials-card-two">
                        <div className="rating">
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                        </div>
                        <p>“Morbi porttitor ligula id varius consectetur. Integer ipsum justo, congue sit amet massa vel, porttitor semper magna. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus.”</p>
                        <div className="content">
                            <img src="assets/images/testimonials/testimonials-img3.jpg" alt="testimonials" />
                            <h3>Cory zamora</h3>
                            <span>Photographer</span>
                        </div>
                        <div className="quote"> <i className="flaticon-quote"></i></div>
                    </div>
                    <div className="testimonials-card-two">
                        <div className="rating">
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                        </div>
                        <p>“Morbi porttitor ligula id varius consectetur. Integer ipsum justo, congue sit amet massa vel, porttitor semper magna. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus.”</p>
                        <div className="content">
                            <img src="assets/images/testimonials/testimonials-img3.jpg" alt="testimonials" />
                            <h3>Jonquil von</h3>
                            <span>Photographer</span>
                        </div>
                        <div className="quote"> <i className="flaticon-quote"></i></div>
                    </div>
                </div>
            </div>
        </div>
       
        <div className="brand-area ptb-100">
            <div className="container">
                <div className="brand-slider owl-carousel owl-theme">
                     <div className="brand-item">
                        <img src="assets/images/brand-logo/1.png" className="brand-item-logo1" alt="Images"/>
                        <img src="assets/images/brand-logo/brand-logo1.png" className="brand-item-logo2" alt="Images"/>
                    </div>

                    <div className="brand-item">
                        <img src="assets/images/brand-logo/2.png" className="brand-item-logo1" alt="Images"/>
                        <img src="assets/images/brand-logo/brand-logo2.png" className="brand-item-logo2" alt="Images"/>
                    </div>

                    <div className="brand-item">
                        <img src="assets/images/brand-logo/3.png" className="brand-item-logo1" alt="Images"/>
                        <img src="assets/images/brand-logo/brand-logo3.png" className="brand-item-logo2" alt="Images"/>
                    </div>

                    <div className="brand-item">
                        <img src="assets/images/brand-logo/4.png" className="brand-item-logo1" alt="Images"/>
                        <img src="assets/images/brand-logo/brand-logo4.png" className="brand-item-logo2" alt="Images"/>
                    </div>

                    <div className="brand-item">
                        <img src="assets/images/brand-logo/5.png" className="brand-item-logo1" alt="Images"/>
                        <img src="assets/images/brand-logo/brand-logo5.png" className="brand-item-logo2" alt="Images"/>
                    </div>

                    <div className="brand-item">
                        <img src="assets/images/brand-logo/6.png" className="brand-item-logo1" alt="Images" />
                        <img src="assets/images/brand-logo/brand-logo6.png" className="brand-item-logo2" alt="Images" />
                    </div>
                </div>
            </div>
        </div>
       
        <div className="instructors-area pb-70">
            <div className="container">
                <div className="section-title text-center mb-45">
                    <h2>Meet our top instructor</h2>
                </div>
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <div className="instructors-card">
                            <a href="instructors-details.html">
                                <img src="assets/images/instructors/instructors-img1.jpg" alt="Team Images" />
                            </a>
                            <div className="content">
                                <ul className="instructors-social">
                                    <li className="share-btn"><i className="ri-add-line"></i></li>
                                    <li>
                                        <a href="https://www.facebook.com/" target="_blank">
                                            <i className="ri-facebook-fill"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/" target="_blank">
                                            <i className="ri-instagram-line"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/" target="_blank">
                                            <i className="ri-twitter-fill"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/" target="_blank">
                                            <i className="ri-linkedin-box-line"></i>
                                        </a>
                                    </li>
                                </ul>
                                <h3><a href="instructors-details.html">Sally welch</a></h3>
                                <span>Web designer</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="instructors-card">
                            <a href="instructors-details.html">
                                <img src="assets/images/instructors/instructors-img2.jpg" alt="Team Images"/>
                            </a>
                            <div className="content">
                                <ul className="instructors-social">
                                    <li className="share-btn"><i className="ri-add-line"></i></li>
                                    <li>
                                        <a href="https://www.facebook.com/" target="_blank">
                                            <i className="ri-facebook-fill"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/" target="_blank">
                                            <i className="ri-instagram-line"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/" target="_blank">
                                            <i className="ri-twitter-fill"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/" target="_blank">
                                            <i className="ri-linkedin-box-line"></i>
                                        </a>
                                    </li>
                                </ul>
                                <h3><a href="instructors-details.html">Jesse joslin</a></h3>
                                <span>Content strategist</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="instructors-card">
                            <a href="instructors-details.html">
                                <img src="assets/images/instructors/instructors-img3.jpg" alt="Team Images"/>
                            </a>
                            <div className="content">
                                <ul className="instructors-social">
                                    <li className="share-btn"><i className="ri-add-line"></i></li>
                                    <li>
                                        <a href="https://www.facebook.com/" target="_blank">
                                            <i className="ri-facebook-fill"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/" target="_blank">
                                            <i className="ri-instagram-line"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/" target="_blank">
                                            <i className="ri-twitter-fill"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/" target="_blank">
                                            <i className="ri-linkedin-box-line"></i>
                                        </a>
                                    </li>
                                </ul>
                                <h3><a href="instructors-details.html">Lance altman</a></h3>
                                <span>Photographer</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="instructors-card">
                            <a href="instructors-details.html">
                                <img src="assets/images/instructors/instructors-img4.jpg" alt="Team Images"/>
                            </a>
                            <div className="content">
                                <ul className="instructors-social">
                                    <li className="share-btn"><i className="ri-add-line"></i></li>
                                    <li>
                                        <a href="https://www.facebook.com/" target="_blank">
                                            <i className="ri-facebook-fill"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/" target="_blank">
                                            <i className="ri-instagram-line"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/" target="_blank">
                                            <i className="ri-twitter-fill"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/" target="_blank">
                                            <i className="ri-linkedin-box-line"></i>
                                        </a>
                                    </li>
                                </ul>
                                <h3><a href="instructors-details.html">Jonquil von</a></h3>
                                <span>Art director</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
         <Newsletter/>
         <LoadJscript/>
      </main>
    );
  }
  
  export default About;  